module.exports = {"id":"dp4_3l1q4","text":"Supporting Wellbeing","instructions":"AI-based virtual assistants may have limitations when supporting human wellbeing.","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"4.3","questionType":"PickOne","random":false,"options":[{"id":"dp4_3l1q4-a1","text":"True","score":1.8},{"id":"dp4_3l1q4-a2","text":"Not sure","score":0},{"id":"dp4_3l1q4-a3","text":"False","score":0}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat4.3/l1q4.json
// module id = 1247
// module chunks = 41